import { render } from "./SectionOverTime.vue?vue&type=template&id=5cd615c1&scoped=true"
import script from "./SectionOverTime.vue?vue&type=script&lang=js"
export * from "./SectionOverTime.vue?vue&type=script&lang=js"

import "./SectionOverTime.vue?vue&type=style&index=0&id=5cd615c1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd615c1"]])

export default __exports__